import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import print from 'print-js';
import axios from 'axios';

import { API_HOST, STATIC_HOST, HTTP_PROTOCOL } from '../../config';
import { getLabels4Bookings } from '../../state/services/bookingService';
import LoadingOverlay from 'react-loading-overlay';
import { CARTONS } from '../../commons/constants';

class BookingSetsView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessage: null,
            items: [],
            cartonItems: [],
            nonCartonItems: [],
            activeTabInd: 1,
            sortBy: 'group',
            isFirstRender: true,
            selectedLabelType: 'label',
            merged_label_url: null,
            is_merging_labels: false,
        };
    }

    static propTypes = {
        history: PropTypes.object,
        match: PropTypes.object,
        getLabels4Bookings: PropTypes.func.required,
        bookingsLabels: PropTypes.array,
        bookingSet: PropTypes.object,
        clientname: PropTypes.string,
        loadingBookingsLabels: PropTypes.bool,
    };

    componentDidMount() {
        this.props.getLabels4Bookings(this.props.match.params.id, this.state.sortBy, this.state.activeTabInd, this.state.selectedLabelType);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedLabelType !== this.state.selectedLabelType) {
            this.props.getLabels4Bookings(this.props.match.params.id, this.state.sortBy, this.state.activeTabInd, this.state.selectedLabelType);
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const {errorMessage, bookingsLabels} = newProps;

        if (errorMessage) {
            if (errorMessage === 'Order does not exist!') {
                this.setState({errorMessage: 'A Freight booking does not exist for this Sales Order. Please go to Pronto Sales Orders, \
                click the "Freight Deliver-ME" button, select a valid freight option and when complete click the "Send Booking Now" button at the bottom of the screen. \
                Your booking will then be ready for freight and freight labels can be printed from the Pronto "Enquire by Package" screen.'});
            } else {
                this.setState({errorMessage});
            }
        }
        if (bookingsLabels) {
            let items = [];
            let cartonItems = [];
            let nonCartonItems = [];
            bookingsLabels.map(booking => {
                if (this.state.sortBy === 'order_number') {
                    if (booking.b_client_order_num && !items.includes(booking.b_client_order_num)) {
                        items.push(booking.b_client_order_num);
                    }                            
                } else if (this.state.sortBy === 'group') {
                    Object.keys(booking.sscc_obj).map(key => {
                        booking.sscc_obj[key].map(item => {
                            if (item.e_bin_number) {
                                if (CARTONS.includes(item.e_type_of_packaging.toUpperCase())) {
                                    if (!cartonItems.includes(item.e_bin_number)) {
                                        cartonItems.push(item.e_bin_number);
                                    }
                                } else if(!nonCartonItems.includes(item.e_bin_number)) {
                                    nonCartonItems.push(item.e_bin_number);
                                }
                            }
                        });
                    });
                } else{
                    Object.keys(booking.sscc_obj).map(key => {
                        booking.sscc_obj[key].map(item => {
                            if (this.state.sortBy === 'product_name') {
                                if (!items.includes(item.e_item)) {
                                    items.push(item.e_item);
                                }
                            } else if (this.state.sortBy === 'bin_number') {
                                if (item.e_bin_number && !items.includes(item.e_bin_number)) {
                                    items.push(item.e_bin_number);
                                }                            
                            }
                        });
                    });
                }
            });
            if (
                this.state.isFirstRender && 
                this.state.sortBy === 'bin_number' &&
                items.length === 0
            ) {
                alert('No bin numbers. Please use other sort option.');
            }
            this.setState({items: items.sort(Intl.Collator().compare)});
            this.setState({cartonItems: cartonItems.sort(Intl.Collator().compare)});
            this.setState({nonCartonItems: nonCartonItems.sort(Intl.Collator().compare)});
            this.setState({ isFirstRender: false});
        }
    }

    notify = (text) => toast(text);

    onClickPreview(url) {
        const token = localStorage.getItem('token');
        const identifer = this.props.match.params.id;
        const {sortBy, activeTabInd, selectedLabelType} = this.state;
        const options = {
            method: 'post',
            headers: {'Authorization': 'JWT ' + token},
            url: `${HTTP_PROTOCOL}://${API_HOST}/booking/merge_labels/?id=${identifer}&sort_by=${sortBy}&is_shipping_label=${activeTabInd}&label_type=${selectedLabelType}`,
        };
        this.setState({is_merging_labels: true});

        axios(options).then((response) => {
            this.setState({is_merging_labels: false});
            if (response.data.success) {
                url = response.data.url;
                this.setState({merged_label_url: url});
                if (url) {
                    if (url && url.length > 0) {
                        const win = window.open(HTTP_PROTOCOL + '://' + STATIC_HOST + '/pdfs/' + url, '_blank');
                        win.focus();
                    } else {
                        this.notify('Has no label');
                    }
                }
            } else if (response.data.message) {
                alert(response.data.message);
            }
        });
    }

    onClickPrint(pdf = null) {
        print({printable: pdf, type: 'pdf', showModal: true, base64: true});
    }

    onClickDownload(pdfUrl) {
        const {bookingsLabels} = this.props;
        const token = localStorage.getItem('token');

        const options = {
            method: 'post',
            url: HTTP_PROTOCOL + '://' + API_HOST + '/download/',
            headers: {'Authorization': 'JWT ' + token},
            data: {url: pdfUrl, downloadOption: 'zpl', id: bookingsLabels['id']},
            responseType: 'blob', // important
        };

        axios(options).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'zpl.zip');
            document.body.appendChild(link);
            link.click();
        });
    }

    onClickTab(activeTabInd) {
        this.props.getLabels4Bookings(this.props.match.params.id, this.state.sortBy, activeTabInd, this.state.selectedLabelType);
        this.setState({ activeTabInd });
    }

    onChangeSortBy(sortBy) {
        this.props.getLabels4Bookings(this.props.match.params.id, sortBy, this.state.activeTabInd, this.state.selectedLabelType);
        this.setState({ sortBy });
    }

    checkValidPackaging(packagingType, isCarton) {
        if (!packagingType) {
            return false;
        }
        if (isCarton && CARTONS.includes(packagingType.toUpperCase())) {
            return true;
        } else if (!isCarton && !CARTONS.includes(packagingType.toUpperCase())) {
            return true;
        }
        return false;
    }

    getLabelsTable(bookingsLabels, item, isCarton) {
        let trs = [];
        if (bookingsLabels) {
            bookingsLabels.map(bookingLabel => {
                let index = 0;
                if (this.state.sortBy !== 'order_number' || bookingLabel.b_client_order_num == item) {
                    for (const value of Object.entries(bookingLabel.sscc_obj)) {
                        const sscc = value[0];
        
                        bookingLabel.sscc_obj[sscc]
                            .filter((sscc_info) =>
                                (this.state.sortBy === 'product_name' && sscc_info.e_item == item) ||
                                (this.state.sortBy === 'bin_number' && sscc_info.e_bin_number == item) ||
                                (this.state.sortBy === 'group' && sscc_info.e_bin_number == item && this.checkValidPackaging(sscc_info.e_type_of_packaging, isCarton)) ||
                                this.state.sortBy === 'order_number'
                            ).map((sscc_info, sscc_info_index) => {
                                index++;
                                const tr = (
                                    <tr key={index}>
                                        {sscc_info_index === 0 && <td rowSpan={bookingLabel.sscc_obj[sscc].length.toString()}>{sscc}</td>}
                                        <td>{sscc_info['e_item_type']}</td>
                                        <td>{sscc_info['e_item']}</td>
                                        <td>{sscc_info['e_bin_number']}</td>
                                        <td>{sscc_info['e_qty']}</td>
                                        <td>{sscc_info['e_type_of_packaging']}</td>
                                        <td>{sscc_info['e_dimLength']}</td>
                                        <td>{sscc_info['e_dimWidth']}</td>
                                        <td>{sscc_info['e_dimHeight']}</td>
                                        <td>{sscc_info['e_dimUOM']}</td>
                                        <td>{sscc_info['e_weightPerEach']}</td>
                                        <td>{sscc_info['e_weightUOM']}</td>
                                        {sscc_info_index === 0 &&
                                            <td rowSpan={bookingLabel.sscc_obj[sscc].length.toString()}>
                                                <Button
                                                    color="info"
                                                    disabled={!sscc_info.is_available && 'disabled'}
                                                    onClick={() => this.onClickPreview(sscc_info['url'])}
                                                    title={sscc_info.is_available ? 'Click to preview for this label' : 'Please rebuild the label'}
                                                >
                                                    Preview
                                                </Button>
                                                {sscc_info['pdf'] &&(
                                                    <Button
                                                        color="primary"
                                                        disabled={!sscc_info.is_available && 'disabled'}
                                                        onClick={() => this.onClickPrint(sscc_info['pdf'])}
                                                        title={sscc_info.is_available ? 'Click to print for this label' : 'Please rebuild the label'}
                                                    >
                                                        Print
                                                    </Button>
                                                )}
                                                <Button
                                                    color="primary"
                                                    disabled={!sscc_info.is_available && 'disabled'}
                                                    onClick={() => this.onClickDownload(sscc_info['url'])}
                                                    title={sscc_info.is_available ? 'Click to download for this label' : 'Please rebuild the label'}
                                                >
                                                    Download(ZPL)
                                                </Button>
                                            </td>
                                        }
                                    </tr>
                                );
                                trs.push(tr);
                            });
                    }
                }
            });
        }
        return trs;
    }


    render() {
        const {bookingsLabels, bookingSet, loadingBookingsLabels} = this.props;
        const {errorMessage, sortBy, activeTabInd, items, cartonItems, nonCartonItems, merged_label_url, is_merging_labels} = this.state;
        const fpCount = bookingsLabels ? [...new Set(bookingsLabels.map(item => item.vx_freight_provider))].length : 0;

        let linesCount = 0;
        let missingLabelsCount = 0;
        if (bookingsLabels) {
            bookingsLabels.map(item => {
                linesCount += Object.keys(item.sscc_obj).length;
            });
            missingLabelsCount = bookingsLabels.filter(booking => !booking.url).length;
        }

        return (
            <section className="label bookingsets-view">
                {!bookingsLabels ?
                    errorMessage ?
                        <div className="error-msg">
                            <p className="">
                                {errorMessage}
                            </p>
                        </div>
                        :
                        <p className="info">Loading...<br /><br />Your PDF labels are now being merged into your selected sorting order. This process is now loading and may take a few minutes depending on the number of booking lines you have.<br />Please do not refresh the browser page before the labels appear. If you do so it will slow the process even further.if you believe this process has hung,<br /> please contact Deliver-ME support and we will look into it for you.</p>
                    :
                    <div>
                        <h4><i className="fa fa-circle"></i> Main Info:</h4>

                        <div className="main-info" >
                            <p><strong>Set Name: </strong>{bookingSet.name}</p>
                            <p><strong>Freight Providers Count: </strong>{fpCount}</p>
                            <p><strong>Bookings Count: </strong>{bookingsLabels.length}</p>
                            <p className={missingLabelsCount > 0 ? 'red' : ''}><strong>Missing Label Count: </strong>{missingLabelsCount}</p>
                            <p><strong>Lines Count: </strong>{linesCount}</p>
                        </div>

                        {bookingsLabels.map((item, index) => (
                            <div className="main-info" key={index}>
                                <p><strong>DME Booking ID: </strong>{item.b_bookingID_Visual}</p>
                                <p><strong>Client order number: </strong>{item.b_client_order_num}</p>
                                <p><strong>Freight provider: </strong>{item.vx_freight_provider}</p>
                                {item.quotes_cnt === 0 &&
                                    <p>
                                        <strong>Error: </strong>
                                        Sales order {item['b_client_order_num']} has either address and / or item line errors in it preventing freight being booked. <br />
                                        Please go Deliver-ME booking <a href={`/booking/?bookingid=${item.id}`} target='_blank' rel="noopener noreferrer">{item.id}</a> and review the address and line information. <br />
                                        When complete click &apos;Update&apos; and then &apos;Price & Time Calc (FC)&apos;. Select the appropriate provider. <br />
                                        Your booking will then be ready for freight and freight labels can be printed from the Pronto &apos;Enquire by Package&apos; screen.
                                    </p>
                                }
                            </div>
                        ))}
                        <br />
                        <div className="tabs">
                            <div className="scrollmenu">
                                <a className={activeTabInd === 1 ? 'active' : ''} onClick={() => this.onClickTab(1)}>Shipping Label</a>
                                <a className={activeTabInd === 0 ? 'active' : ''} onClick={() => this.onClickTab(0)}>Carton Label</a>
                            </div>
                        </div>
                        <hr />
                        <div className="label-type-selector">
                            <input type="radio"
                                id="label-type"
                                value="label"
                                checked={this.state.selectedLabelType === 'label'}
                                onChange={(e) => this.setState({ selectedLabelType: e.target.value })}
                            />
                            <label htmlFor="label-type">Label</label>
                            <input type="radio"
                                id="consignment-type"
                                value="consignment"
                                checked={this.state.selectedLabelType === 'consignment'}
                                onChange={(e) => this.setState({ selectedLabelType: e.target.value })}
                            />
                            <label htmlFor="consignment-type">Consignment</label>
                        </div>
                        <div className="labels-option">
                            <div>
                                <span>Sort by: </span>
                                <select
                                    name="sortBy"
                                    value={sortBy}
                                    onChange={e => this.onChangeSortBy(e.target.value)}
                                >
                                    <option value="bin_number">Bin Number</option>
                                    <option value="product_name">Product Name</option>
                                    <option value="order_number">Order Number</option>
                                    <option value="group">Group</option>
                                </select>
                            </div>
                        </div>
                        <LoadingOverlay
                            active={loadingBookingsLabels || is_merging_labels}
                            spinner
                            text='Loading...'
                            styles={{
                                spinner: (base) => ({
                                    ...base,
                                    '& svg circle': {
                                        stroke: '#048abb'
                                    }
                                })
                            }}
                        >
                            <div>
                                {items.length === 0 && cartonItems.length === 0 && nonCartonItems.length === 0  ? (
                                    <div className="error-msg">
                                        <p className="">
                                            {this.state.selectedLabelType === 'label' ? 'Label' : 'Consignment'} does not exist!
                                        </p>
                                    </div>
                                ) : (
                                    <div>
                                        <h4><i className="fa fa-circle"></i> Merged:</h4>
                                        <div className="action">
                                            {bookingSet &&
                                                <Button
                                                    color="info"
                                                    disabled={bookingSet ? false : true}
                                                    onClick={() => this.onClickPreview()}
                                                >
                                                    Preview
                                                </Button>
                                            }
                                            {bookingSet.pdf &&
                                                <Button
                                                    color="primary"
                                                    onClick={() => this.onClickPrint(bookingSet.pdf)}
                                                    title={bookingSet.pdf ? 'Click to print for entire labels' : 'Please rebuild the labels'}
                                                >
                                                    Print
                                                </Button>
                                            }
                                            {merged_label_url &&
                                                <Button
                                                    color="primary"
                                                    disabled={merged_label_url ? false : true}
                                                    onClick={() => this.onClickDownload(merged_label_url)}
                                                >
                                                    Download(ZPL)
                                                </Button>
                                            }
                                        </div>
                                    </div>
                                )}                                
                                <div>
                                    {sortBy ==='group' ? (
                                        <div>
                                            {cartonItems.map((item, index) => (
                                                <div key={index}>
                                                    <h4><i className="fa fa-circle"></i> {`Bin Number - ${item}`}</h4>
                                                    <div className="sscc-info">
                                                        <table className="table table-hover table-bordered sortable fixed_headers">
                                                            <thead>
                                                                <tr>
                                                                    <th style={{width: '15%'}}>SSCC</th>
                                                                    <th style={{width: '10%'}}>Code</th>
                                                                    <th style={{width: '20%'}}>Description</th>
                                                                    <th style={{width: '20%'}}>Bin Number</th>
                                                                    <th style={{width: '10%'}}>Qty</th>
                                                                    <th style={{width: '10%'}}>Type of Package</th>
                                                                    <th style={{width: '10%'}}>Length</th>
                                                                    <th style={{width: '10%'}}>Width</th>
                                                                    <th style={{width: '10%'}}>Height</th>
                                                                    <th style={{width: '10%'}}>Dimension UOM</th>
                                                                    <th style={{width: '10%'}}>Weight</th>
                                                                    <th style={{width: '10%'}}>Weight UOM</th>
                                                                    {<th style={{width: '10%'}}>Preview</th>}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.getLabelsTable(bookingsLabels, item, true)}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="action">
                                                        {bookingSet.items[item] && bookingSet.items[item].url &&
                                                            <Button
                                                                color="info"
                                                                disabled={bookingSet.items[item].url ? false : true}
                                                                onClick={() => this.onClickPreview(bookingSet.items[item].url)}
                                                                title={bookingSet.items[item].pdf ? 'Click to preview for this product' : 'Please rebuild the label'}
                                                            >
                                                                Preview
                                                            </Button>
                                                        }
                                                        {bookingSet.items[item] && bookingSet.items[item].pdf &&
                                                            <Button
                                                                color="primary"
                                                                onClick={() => this.onClickPrint(bookingSet.items[item].pdf)}
                                                                title={bookingSet.items[item].pdf ? 'Click to print for this product' : 'Please rebuild the label'}
                                                            >
                                                                Print
                                                            </Button>
                                                        }
                                                        {bookingSet.items[item] && bookingSet.items[item].url &&
                                                            <Button
                                                                color="primary"
                                                                disabled={bookingSet.items[item].url ? false : true}
                                                                onClick={() => this.onClickDownload(bookingSet.items[item].url)}
                                                                title={bookingSet.items[item].pdf ? 'Click to download for this product' : 'Please rebuild the label'}
                                                            >
                                                                Download(ZPL)
                                                            </Button>
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                            {nonCartonItems.map((item, index) => (
                                                <div key={index}>
                                                    <h4><i className="fa fa-circle"></i> {`Bin Number - ${item}`}</h4>
                                                    <div className="sscc-info">
                                                        <table className="table table-hover table-bordered sortable fixed_headers">
                                                            <thead>
                                                                <tr>
                                                                    <th style={{width: '15%'}}>SSCC</th>
                                                                    <th style={{width: '10%'}}>Code</th>
                                                                    <th style={{width: '20%'}}>Description</th>
                                                                    <th style={{width: '20%'}}>Bin Number</th>
                                                                    <th style={{width: '10%'}}>Qty</th>
                                                                    <th style={{width: '10%'}}>Type of Package</th>
                                                                    <th style={{width: '10%'}}>Length</th>
                                                                    <th style={{width: '10%'}}>Width</th>
                                                                    <th style={{width: '10%'}}>Height</th>
                                                                    <th style={{width: '10%'}}>Dimension UOM</th>
                                                                    <th style={{width: '10%'}}>Weight</th>
                                                                    <th style={{width: '10%'}}>Weight UOM</th>
                                                                    {<th style={{width: '10%'}}>Preview</th>}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.getLabelsTable(bookingsLabels, item, false)}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="action">
                                                        {bookingSet.items[item] && bookingSet.items[item].url &&
                                                            <Button
                                                                color="info"
                                                                disabled={bookingSet.items[item].url ? false : true}
                                                                onClick={() => this.onClickPreview(bookingSet.items[item].url)}
                                                                title={bookingSet.items[item].pdf ? 'Click to preview for this product' : 'Please rebuild the label'}
                                                            >
                                                                Preview
                                                            </Button>
                                                        }
                                                        {bookingSet.items[item] && bookingSet.items[item].pdf &&
                                                            <Button
                                                                color="primary"
                                                                onClick={() => this.onClickPrint(bookingSet.items[item].pdf)}
                                                                title={bookingSet.items[item].pdf ? 'Click to print for this product' : 'Please rebuild the label'}
                                                            >
                                                                Print
                                                            </Button>
                                                        }
                                                        {bookingSet.items[item] && bookingSet.items[item].url &&
                                                            <Button
                                                                color="primary"
                                                                disabled={bookingSet.items[item].url ? false : true}
                                                                onClick={() => this.onClickDownload(bookingSet.items[item].url)}
                                                                title={bookingSet.items[item].pdf ? 'Click to download for this product' : 'Please rebuild the label'}
                                                            >
                                                                Download(ZPL)
                                                            </Button>
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div>
                                            {items.map((item, index) => (
                                                <div key={index}>
                                                    <h4><i className="fa fa-circle"></i> {sortBy ==='product_name' ? `Product${index+1} (${item})` : sortBy ==='bin_number' ? `Bin Number - ${item}`: `Order Number - ${item}`}</h4>
                                                    <div className="sscc-info">
                                                        <table className="table table-hover table-bordered sortable fixed_headers">
                                                            <thead>
                                                                <tr>
                                                                    <th style={{width: '15%'}}>SSCC</th>
                                                                    <th style={{width: '10%'}}>Code</th>
                                                                    <th style={{width: '20%'}}>Description</th>
                                                                    <th style={{width: '20%'}}>Bin Number</th>
                                                                    <th style={{width: '10%'}}>Qty</th>
                                                                    <th style={{width: '10%'}}>Type of Package</th>
                                                                    <th style={{width: '10%'}}>Length</th>
                                                                    <th style={{width: '10%'}}>Width</th>
                                                                    <th style={{width: '10%'}}>Height</th>
                                                                    <th style={{width: '10%'}}>Dimension UOM</th>
                                                                    <th style={{width: '10%'}}>Weight</th>
                                                                    <th style={{width: '10%'}}>Weight UOM</th>
                                                                    {<th style={{width: '10%'}}>Preview</th>}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.getLabelsTable(bookingsLabels, item)}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="action">
                                                        {bookingSet.items[item] && bookingSet.items[item].url &&
                                                            <Button
                                                                color="info"
                                                                disabled={bookingSet.items[item].url ? false : true}
                                                                onClick={() => this.onClickPreview(bookingSet.items[item].url)}
                                                                title={bookingSet.items[item].pdf ? 'Click to preview for this product' : 'Please rebuild the label'}
                                                            >
                                                                Preview
                                                            </Button>
                                                        }
                                                        {bookingSet.items[item] && bookingSet.items[item].pdf &&
                                                            <Button
                                                                color="primary"
                                                                onClick={() => this.onClickPrint(bookingSet.items[item].pdf)}
                                                                title={bookingSet.items[item].pdf ? 'Click to print for this product' : 'Please rebuild the label'}
                                                            >
                                                                Print
                                                            </Button>
                                                        }
                                                        {bookingSet.items[item] && bookingSet.items[item].url &&
                                                            <Button
                                                                color="primary"
                                                                disabled={bookingSet.items[item].url ? false : true}
                                                                onClick={() => this.onClickDownload(bookingSet.items[item].url)}
                                                                title={bookingSet.items[item].pdf ? 'Click to download for this product' : 'Please rebuild the label'}
                                                            >
                                                                Download(ZPL)
                                                            </Button>
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </LoadingOverlay>
                    </div>
                }

                
            </section>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        clientname: state.auth.clientname,
        errorMessage: state.booking.errorMessage,
        bookingsLabels: state.booking.bookingsLabels,
        bookingSet: state.booking.bookingSet,
        bookings: state.booking.bookings,
        loadingBookingsLabels: state.booking.loadingBookingsLabels,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLabels4Bookings: (identifier, sortBy, isShippingLabel, labelType) => dispatch(getLabels4Bookings(identifier, sortBy, isShippingLabel, labelType)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookingSetsView);



// WEBPACK FOOTER //
// ./src/pages/BookingSets/BookingSetsView.js